import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';
import {
    Button,
    Row,
    Col,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    InputGroup,
    Container
} from 'reactstrap';

import CustomInput from '../../components/CustomInput';
import CustomLabel from '../../components/CustomLabel';

import {
    check_empty_field
} from './validationChecks';

import {
    showLoading,
    showFeatureComingSoon,
    fetchPropertyTenants,
    sendMessage,
    fetchOptions
} from '../../redux/actions';
import { Typeahead } from 'react-bootstrap-typeahead';
import { OCCUPANT_TYPE, colorTheme } from '../../utils/constants';
import CustomPropertySelect from '../../components/CustomPropertySelect';
import { renderTenantSearchMenu } from '../../utils';
import { IonButton } from '@ionic/react';

const mapStateToProps = state => {
    return {
        properties: state.properties,
        tenants: state.tenants,
        units: state.units,
        options: state.options
    };
}

const mapDispatchToProps = {
    showLoading,
    fetchPropertyTenants,
    showFeatureComingSoon,
    sendMessage,
    fetchOptions
};


class SendMessageForm extends React.Component{
    constructor(props) {
        super(props);
        let propertyId = "";
        let tenantDetails = null;
        let tenants = [];
        let tenantOptions = [];

        if (props.tenant){
            tenantDetails = this.getTenantOption(props.tenant)
            tenants = [tenantDetails];
            propertyId = props.tenant.propertyId;
            tenantOptions = tenants;
        }


        this.state = {
            tenants,
            tenantDetails,
            propertyId,
            properties: [],
            message: "",
            tenantOptions,
            selectAllTenants: false,
            errors: {
                message: "",
                tenants: "",
            },
            numErrors: 0
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSelectAllTenants = this.handleSelectAllTenants.bind(this);
    }

    async setTenantOptions(propertyId=""){
        let tenantOptions = [];

        if(propertyId){
            const action = await this.props.fetchPropertyTenants({propertyIds:[propertyId]});
            if(action && action.payload && action.payload.tenants){
                for(let tenant of Object.values(action.payload.tenants)){
                    if(!tenant.archived){
                        tenantOptions.push(this.getTenantOption(tenant));
                    }
                }
            }
        }
        this.setState({
            tenantOptions
        });
    }

    async componentDidMount(){
        if (_.isEmpty(this.props.options)) {
            this.props.showLoading(true);
            await this.props.fetchOptions();
            this.props.showLoading(false);
        }
        if(Object.values(this.props.properties).length === 1){
            let propertyId = Object.values(this.props.properties)[0].propertyId;
            this.setTenantOptions(propertyId);
            this.setState({propertyId: propertyId});
        } else {
            if (this.state.propertyId) {
                this.setTenantOptions(this.state.propertyId);
            }
        }

        this.setState({properties: Object.values(this.props.properties)});

        // Mixpanel.track("Send Message form: mounted");
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.propertyId !== this.state.propertyId) {
          this.setMessageFormValues();
        }
      }

    getTenantOption(tenant){
        if(tenant){
            let label = "";
            if (tenant?.archived) {
                label += "[Archived] - ";
            }
            label += tenant.firstName + " " + tenant.lastName;
            if(tenant.propertyId in this.props.properties){
                label += " (" + this.props.properties[tenant.propertyId].propertyName

                if(tenant.unitId in this.props.units){
                    label += " : " + this.props.units[tenant.unitId].unitName
                }

                label += ")"
            }

            return {
                id: tenant.tenantId,
                tenantDetails: tenant,
                label
            };
        }else{
            return null;
        }

    }


    validateInput(name, value){
        let val = String(value);
        let isValid = true;
        let errors = this.state.errors;
        let checks = [];
        switch(name){
            case "tenants":
                checks = [check_empty_field]
                break;
            case "message":
                checks = [check_empty_field]
                break;
            default:
                break;
        }
        for (let index in checks){
            let previousError = errors[name];
            errors[name] = checks[index](val);
            if (errors[name].length > 0){
                if (previousError.length == 0){
                    this.setState((prevState)=>({numErrors: prevState.numErrors + 1}));
                }
                isValid = false;
                break;
            }else if(previousError.length > 0){
                this.setState((prevState)=>({numErrors: prevState.numErrors - 1}));
            }
        }
        return isValid;
    }

    handleChange(event) {
        let name = event.target.name;
        let val = event.target.value;
        this.setState({[name]: val});
        this.validateInput(name, val);
    }

    async handleTenantChangedOptions(name, selected) {
        await this.setState({
            [name]: selected,
            selectAllTenants: false
         });
        this.validateInput(name, selected);
      }

    async handleSelectAllTenants(propertyId="") {
        if (!this.state.selectAllTenants) {
            const selectedTenants = [...this.state.tenantOptions];
            this.setState((prevState) => ({
                selectAllTenants: propertyId ? !prevState.selectAllTenants: false,
                tenants: selectedTenants
            }));
            this.validateInput("tenants", selectedTenants);
        } else {
          this.setState((prevState) => ({
            selectAllTenants: !prevState.selectAllTenants
          }));
        }
      }


    async handleSubmit(event) {
        event.preventDefault();
        let fields = ["message", "tenants"];
        let invalid_fields = fields.filter((field)=> !(this.validateInput(field, this.state[field])));
        if (invalid_fields.length == 0) {
            this.props.showLoading(true);
            let action = await this.props.sendMessage({
                propertyIds: [],
                tenantIds: this.state.tenants.map(tenants => tenants.id),
                customMessage: this.state.message
            })
            if (!action.errors){
                this.setMessageFormValues();
            }
        }
        Mixpanel.track("Send Message form: submit btn");
    }

    setMessageFormValues(tenants=[], message="", selectAllTenants=false){
        this.setState({
            tenants, message, selectAllTenants
        });
    }

    handleCancelSendMessage(event){
        event.preventDefault();
        this.setMessageFormValues();
        Mixpanel.track("Send Message form: cancel btn");
    }

    async handleSelectProperty(event) {
        event.preventDefault();
        let value = event.target.value;
        await this.props.showLoading(true);
        this.setState((prevState) => {
          let { propertyId } = prevState;
          let tenants=[];
          if (propertyId !== value) {
            propertyId = value;
          }
          return {
            propertyId,
            tenants,
            selectAllTenants: false
          };
        });

        if (propertyId !== value) {
          await this.setTenantOptions(value);
          if (value === "") {
            this.props.showLoading(false);
          }
        }
      }

    renderFields(){
        return (<React.Fragment>
            {/* Select Tenant */}
            <FormGroup row>
                <CustomLabel
                    xs={12} sm={3} md={3}
                    for="propertyId">
                        Select Property
                </CustomLabel>

                <Col style={{maxWidth: '28.125em'}} xs={12} sm={12} md={12}>
                    <CustomInput
                        type="select"
                        id="propertyId"
                        name="propertyId"
                        className="mr-2"
                        disabled={this.state.readOnly}
                        onChange={this.handleSelectProperty.bind(this)}
                        value={this.state.propertyId}
                    >
                        <CustomPropertySelect propertiesArray={this.state.properties}/>
                    </CustomInput>
                </Col>
            </FormGroup>

            <FormGroup row>
                <CustomLabel
                    for="tenantId">
                        Select {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}(s)
                </CustomLabel>

                <Col className="mt-2" style={{maxWidth: '28.125em'}} xs={12} sm={12} md={12}>
                    {this.state.propertyId && (<div>
                        <FormGroup className='ml-4'>
                        <small>
                            <Input
                            name='tenants'
                            type="checkbox"
                            checked={this.state.selectAllTenants}
                            onChange={() => this.handleSelectAllTenants(this.state.propertyId)}
                            />{' '}
                            Select all {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"} from this property
                        </small>
                        </FormGroup>
                    </div>)}

                    <Typeahead
                        emptyLabel={this.state.propertyId==="" ? `Please first select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} property.` : `Choose ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"}. No matches found.`}
                        placeholder={`Select ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant(s)" : "member(s)"} ...`}
                        disabled={this.state.readOnly}
                        id="tenants"
                        clearButton
                        multiple
                        options={this.state.tenantOptions}
                        name="tenants"
                        selected={this.state.tenants}
                        paginate={false}
                        maxResults={10000000}  // chose a high number because we don't want to handle pagination. Just show all results.
                        onChange={this.handleTenantChangedOptions.bind(this, "tenants")}
                        renderMenu={renderTenantSearchMenu}
                    >
                    </Typeahead>
                    {this.state.errors.tenants.length > 0 &&
                        <p className="text-danger">{this.state.errors.tenants}
                    </p>}
                </Col>
            </FormGroup>

            {/* Message */}
            <FormGroup row>
                <CustomLabel for="message">
                    Message
                </CustomLabel>

                <Col style={{maxWidth: '28.125em'}} xs={12} sm={12} md={12}>
                    <InputGroup>
                        <Input
                            readOnly={this.state.readOnly}
                            id="message"
                            name="message"
                            type="textarea"
                            placeholder='Message ...'
                            value={this.state.message}
                            onChange={this.handleChange}
                            invalid={this.state.errors.message.length > 0}
                        />
                        <FormFeedback>{this.state.errors.message}</FormFeedback>
                    </InputGroup>
                </Col>
            </FormGroup>

        </React.Fragment>)
    }


    render() {
        return (
            <Container>

                <Row className="mb-4 mt-1">
                    <Col lg={12}>
                        {/* <h3 data-testid="messageFormTitle">Send Message Form</h3> */}
                        <p>Use this form to send a message to some {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants or all tenants" : "members or all members"} within a property.</p>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                    <Form onSubmit={this.handleSubmit.bind(this)}>

                        {this.renderFields()}

                        <Row className="d-flex mb-4 pb-3 border-bottom border-dark justify-content-center">
                            <IonButton type="submit" className="mx-2 shadow"
                                style={{ width: "80% "}}
                                disabled={this.state.numErrors > 0 || this.state.propertyId==null}>
                                Send Message
                            </IonButton>
                            {this.state.tenants && (<IonButton type="submit"
                                fill="outline"
                                style={{ width: "80% "}}
                                className="mx-2 mt-3"
                                onClick={this.handleCancelSendMessage.bind(this)}
                                 >
                                   Clear
                            </IonButton>)}
                        </Row>

                    </Form>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SendMessageForm);